<template>
    <div>
       <div class="flexBox">
        <div class="lefts">
            <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d504d069d29.png" style="width: 12em;" alt="">
            <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20250925/68d505154751a.png" style="width: 18em;margin-top: 30px;" alt="">
        </div>
        <div class="rights">
            <div style="font-size: 2.4em;color: #333;font-weight: bold;margin-bottom: 20px;">申请体验</div>
            <input type="text" placeholder="姓名" v-model="obj.name">
            <input type="text" placeholder="手机号" v-model="obj.mobile">
            <input type="text" placeholder="主营业务" v-model="obj.industry">
            <textarea placeholder="备注" v-model="obj.remark"/>
            <div class="btns" @click="saveBtn">提交</div>
            <div style="color: #808080;font-size: 16px;margin-top: 10px;">请留下您的联系方式，我们将尽快安排专员与您联系</div>
        </div>
       </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'Infos',
	data(){
		return{
			obj: {
				name: '',
				mobile: '',
				industry: '',
				remark: ''
			}
		}
	},
	methods: {
		saveBtn(){
			var query = this.obj
			axios.defaults.headers.common['APPKEY'] = 'official';
			axios.post(window.location.origin + '/user/member/join/apply/hand ',query)
			    .then(res => {
			        console.log('提交信息='+JSON.stringify(res))
					if(res.data.code == 200){
						this.$message.success(res.data.msg);
					}else {
						this.$message.success(res.data.msg);
					}
			})
		},
	}
}
</script>

<style scoped>
.flexBox{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 20px;
}
.lefts{background: #EDF4FF;width: 50%;padding: 180px 0;display: flex;flex-direction: column;align-items: center;}
.rights{width: 50%;display: flex;flex-direction: column;align-items: center;}
input{padding: 15px 25px;width: 400px;border: 1px solid #DDDFE6;border-radius: 10px;margin-top: 20px;font-size: 20px;}
textarea{padding: 15px 25px;width: 400px;border: 1px solid #DDDFE6;border-radius: 10px;margin-top: 20px;font-size: 20px;}
.btns{width: 400px;background: #1773FF; color: #fff;border-radius: 10px;text-align: center;margin-top: 20px;font-size: 22px;padding: 10px 25px;}
</style>